import { createFileRoute } from '@tanstack/react-router';

import OAuthCallbackPage from '@/screens/oauth/callback/page';

export const Route = createFileRoute('/_app/oauth/callback/')({
  component: OAuthCallbackPage,
});
